import PropTypes from 'prop-types';
import React from 'react';

import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import displayAvailabilityShape from 'app/shapes/displayAvailability';
import { rowShape } from 'app/shapes/browse/rows';
import Rows from '../shared/Rows';

import './BrowsePage.scss';

const BrowsePage = ({ displayAvailabilitByMetadataId, pageTitle, rows }) => {
  return (
    <div className="cp-browse-page">
      <ScreenReaderMessage>
        <h1>{pageTitle}</h1>
      </ScreenReaderMessage>
      <Rows displayAvailabilitByMetadataId={displayAvailabilitByMetadataId} rows={rows} />
    </div>
  );
};

BrowsePage.propTypes = {
  displayAvailabilitByMetadataId: PropTypes.objectOf(displayAvailabilityShape).isRequired,
  pageTitle: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(rowShape).isRequired
};

export default BrowsePage;
